import type { CompanyResponseAccordionSection } from '@buxus/shared'
import type { ScreenInteractionContext } from './platform/analytics/interactionAnalytics'
import { trackRichHtmlLinkClick } from './platform/analytics/interactionAnalytics'
import { BuxusAccordion } from './components/BuxusAccordion'

type Props = {
  sections: CompanyResponseAccordionSection[]
  analytics?: ScreenInteractionContext
}

/** Mobile Company Response accordion parity (Actions, Reasons to Notify, etc.). */
export function CompanyResponseAccordions({ sections, analytics }: Props) {
  const defaultExpandedIds = sections.length === 1 ? [sections[0]!.id] : undefined

  return (
    <BuxusAccordion
      className="company-response-accordion hazard-detail-accordion"
      defaultExpandedIds={defaultExpandedIds}
      analytics={analytics}
      items={sections.map((section) => ({
        id: section.id,
        title: section.title,
        content: (
          <div
            className="rich company-response-accordion-body"
            dangerouslySetInnerHTML={{ __html: section.html }}
            onClick={analytics ? (e) => trackRichHtmlLinkClick(e, analytics) : undefined}
          />
        ),
      }))}
    />
  )
}
